<template>
  <div>
    <h1 class="ya-te-page-title mb-12 text-center font-bold leading-none md:mb-12">
      お問い合わせ
    </h1>
    <div
      class="mb-7 border p-5"
      style="border-color: #f03;"
    >
      <h3 class="ya-te-text-red co-display-12 mb-4 text-center font-bold">
        新規お申し込み受付の一時停止について
      </h3>
      <p class="co-display-13 text-left">
        只今、新規のお申し込みを一時停止しております。再開に関するご案内は
        <a
          href="https://ly-academy.yahoo.co.jp/tech/index.html"
          target="_blank"
        >こちら</a>をご確認ください。<br>既にお申し込み済み・学習中のお客様は、原則引き続き受講・各種サポートをご利用いただけます。 ただし、一時停止を受け受講・各種サポート内容に影響があるお客様に対しては、事務局より個別にメールにてご連絡を差し上げます。
      </p>
      <p class="co-display-13 text-left">
        ※受講・サポート内容に影響のないお客様への個別連絡はございません。<br>これにともない、実施していた「2周年キャンペーン」も終了いたしました。
      </p>
    </div>
    <p class="mb-4 ml-4 text-center">
      <a
        href="/ly/terms"
      >利用規約</a>及び<a
        href="/ly/privacypolicy"
      >個人情報の取扱い</a>に同意の上、下記フォームに内容を記入し送信してください。
      <br>
      法人の方は「お問い合わせ内容」の項目に企業名などをご入力の上お問い合わせください。
    </p>
    <div class="mb-7 flex justify-center">
      <div class="co-display-13 bg-co-gray-200 p-4 text-co-gray-500 md:w-5/6">
        <h3 class="mb-2 font-bold leading-none">
          お問い合わせの前にご一読ください
        </h3>
        <p>
          お電話でのお問い合わせはやり取りした内容が記録に残らないため、承っておりません。
          <br>
          お問い合わせ送信後、2営業日以内にご返信差し上げます。
          <br>
          営業時間：10:00～18:00（土日・祝祭日を除く）
        </p>
      </div>
    </div>
    <!-- フォーム -->
    <YaTeContactForm brand="lyta" />
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'
import YaTeContactForm from '~/components/YaTe/YaTeContact/YaTeContactForm.vue'

const options = {
  async setup() {
    definePageMeta({
      layout: 'yate-side-menu'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',

    })
    return {
      title: 'LINEヤフーテックアカデミーお問い合わせ | テックアカデミー',
      meta: [
        ...metaTags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            description: 'LINEヤフーテックアカデミーのお問い合わせフォーム',
            twitterTitle:
              'LINEヤフーテックアカデミーお問い合わせ | テックアカデミー',
            twitterDescription:
              'LINEヤフーテックアカデミーのお問い合わせフォーム',
            twitterImage: '/_nuxt/ogp/yate/og-image.jpg',
            ogDescription: 'LINEヤフーテックアカデミーのお問い合わせフォーム',
            ogTitle:
              'LINEヤフーテックアカデミーお問い合わせ | テックアカデミー',
            ogUrl: '/yahoo/contact',
            ogImage: '/_nuxt/ogp/yate/og-image.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    YaTeContactForm,
  }
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');
</style>
